import React from 'react'
import {Box, Tab, Tabs} from "@mui/material";
import stringUtils from "../../../utils/string_utils"
import commonColorUtils from "../../../utils/common_colors";
import CommonTextWithRoundedShape from '../../../components/CommonTextWithRoundedShape';

const FirstMileOrderTabs = ({activeTabValue, handleOnChangeTabs, commonCount}) => {
    const styleOfTab = {
        width: '150px',
        fontFamily: 'Inter, Arial, sans-serif',
        color: commonColorUtils.primaryGrey600,
        fontWeight: 600,
        margin: '6px 20px',
        fontSize: '14px',
        textTransform: "none",
        '&.Mui-selected': {
            color: commonColorUtils.primaryMainBlue,  // Color when tab is selected
        },
    }
    return (
        <>
            <Tabs value={activeTabValue} onChange={handleOnChangeTabs} sx={{width: '100%',}} TabIndicatorProps={{
                style: {
                    backgroundColor: commonColorUtils.primaryMainBlue,  // Underline color when the tab is selected
                },
            }}>
                <Tab label={<Box display="flex" alignItems="center">
                    {stringUtils.pickup}
                    <CommonTextWithRoundedShape text={commonCount.pickupCount}/>
                </Box>
                } sx={styleOfTab}/>
                <Tab label={<Box display="flex" alignItems="center">
                    {stringUtils.return}
                    <CommonTextWithRoundedShape text={commonCount.returnCount}/>
                </Box>} sx={styleOfTab}/>
                <Tab label={<Box display="flex" alignItems="center">
                    {stringUtils.rto}
                    <CommonTextWithRoundedShape text={commonCount.rtoCount}/>
                </Box>} sx={styleOfTab}/>
            </Tabs>
        </>
    )
}
export default FirstMileOrderTabs